import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import { baseUrl, baseUrlCSRFCookie } from "../../../resources/Constants";
import logo from '../../../resources/img/smileweb.png';
import ReCAPTCHA from "react-google-recaptcha";
import ModalActualizarUsuario from "./ModalActualizarUsuario";
import './Login2.css';

// Instancia axios para hacer solicitud del CSRF Cookie al backend
const axiosInstanceCSRFCookie = axios.create({
    baseURL: baseUrlCSRFCookie,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
    withXSRFToken: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
});

// Instancia axios para autenticación
const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
    withXSRFToken: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
});

function Login2(props) {
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [feedbackType, setFeedbackType] = useState('invalid-feedback');
    const [msg, setMsg] = useState('');
    const [captchaValue, setCaptchaValue] = useState(null);

    // Estados para el Modal de actualización
    const [showActualizarModal, setShowActualizarModal] = useState(false);
    const [actualizarData, setActualizarData] = useState(null);

    let history = useHistory();

    const onCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!captchaValue) {
            setFeedbackType('invalid-feedback visible');
            setMsg('Por favor, completa el captcha');
            return;
        }

        setLoading(true);

        const isEmail = String(login).includes('@');
        const payload = isEmail 
            ? { email: login, password: password } 
            : { login: login, password: password };

        axiosInstanceCSRFCookie.get('/sanctum/csrf-cookie')
            .then(response => {
                axiosInstance.post('/login', payload)
                    .then(
                        response => {
                            setMsg('');
                            setLoading(false);

                            if (response.data.requiere_actualizacion) {
                                setActualizarData(response.data);
                                setShowActualizarModal(true);
                                return;
                            }

                            // Solo usuarios activos (activo=1) reciben token; bloqueo extra por si el API cambia
                            const status = response.data.user_status;
                            if (status != null && String(status) !== '1') {
                                setFeedbackType('invalid-feedback visible');
                                setMsg('Su usuario no tiene acceso activo al sistema. Contacte al administrador de la clínica.');
                                return;
                            }

                            localStorage.setItem('userdata', JSON.stringify(response.data));
                            history.push('/home');
                        }
                    )
                    .catch(
                        err => {
                            setFeedbackType('invalid-feedback visible');
                            const apiMsg = err.response?.data?.message;
                            const status = err.response?.status;
                            if (status === 403 && apiMsg) {
                                setMsg(apiMsg);
                            } else {
                                setMsg(apiMsg || 'No se pudo iniciar sesión. Verifica usuario y contraseña.');
                            }
                            setLoading(false);
                        }
                    )
            })
            .catch(error => {
                const isNetwork = !error.response && (error.code === 'ERR_NETWORK' || error.message === 'Network Error');
                if (process.env.NODE_ENV === 'development') {
                    console.warn('Login: fallo al obtener cookie CSRF / conectar con backend', baseUrlCSRFCookie, error);
                }
                setFeedbackType('invalid-feedback visible');
                setMsg(
                    isNetwork
                        ? `No hay conexión con el backend en ${baseUrlCSRFCookie}. Si usas XAMPP, ajusta REACT_APP_API_URL en .env.development (o ejecuta "php artisan serve" en el puerto 8000).`
                        : 'Error de conexión. Intenta nuevamente.'
                );
                setLoading(false);
            });
    }

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-logo">
                    <img src={logo} alt="SmileWEB Logo" />
                </div>
                
                <h2 className="login-title">¡Bienvenido a SmileWEB!</h2>
                <p className="login-subtitle">Sistema Integral de Gestión Médica y Odontológica</p>

                <form onSubmit={handleSubmit} method="post" noValidate className="login-form">
                    <div className="form-group">
                        <label htmlFor="login">Usuario</label>
                        <div className="input-with-icon">
                            <i className="fas fa-user"></i>
                            <input 
                                type="text" 
                                id="login"
                                className="form-control" 
                                placeholder="Ingresa tu usuario" 
                                autoFocus={true} 
                                onChange={e => setLogin(e.target.value)}
                                value={login}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Contraseña</label>
                        <div className="input-with-icon">
                            <i className="fas fa-lock"></i>
                            <input 
                                type="password" 
                                id="password"
                                className="form-control" 
                                placeholder="Ingresa tu contraseña" 
                                onChange={e => setPassword(e.target.value)}
                                value={password}
                            />
                        </div>
                    </div>

                    <div className="form-group captcha-container">
                        <ReCAPTCHA
                            sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"}
                            onChange={onCaptchaChange}
                        />
                    </div>

                    {msg && (
                        <div className={`alert ${msg.includes('exitos') ? 'alert-success' : 'alert-danger'}`} role="alert">
                            {msg}
                        </div>
                    )}

                    <button type="submit" className="btn-login" disabled={loading}>
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                Ingresando...
                            </>
                        ) : (
                            'Ingresar'
                        )}
                    </button>
                </form>

                <div className="login-links">
                    <Link to={'/request-password'} className="login-link">
                        <i className="fas fa-key"></i> Olvidé mi contraseña
                    </Link>
                </div>
            </div>

            {/* Modal para actualización de seguridad (Fase 1 -> Fase 2) */}
            {showActualizarModal && actualizarData && (
                <ModalActualizarUsuario
                    show={showActualizarModal}
                    data={actualizarData}
                    loginOrigin={login}
                    passwordOrigin={password}
                    onHide={() => setShowActualizarModal(false)}
                    onSuccess={() => {
                        setShowActualizarModal(false);
                        setLogin('');
                        setPassword('');
                        setMsg('¡Actualización exitosa! Por favor ingresa con tu correo electrónico y tu nueva contraseña.');
                        setFeedbackType('valid-feedback visible text-success');
                    }}
                />
            )}

        </div>
    );
}

export default Login2;